import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import "../../../../styles/Pages/Operational/Residential/Hostel/Hostel.style.css";
// icons
import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import SearchIcon from "../../../../assets/Icons/Universal/Search.svg";

import FilterBtn from "../../../../components/Universal/FilterBtn.component";
import HostelBody from "../../../../components/PagesComponents/Operational/Residential/Hostel/HostelBody/HostelBody.component";
import HostelEdit from "../../../../components/PagesComponents/Operational/Residential/Hostel/EditHostel/HostelEdit.component";

import DropDownInput from "../../../../components/Universal/DropDownInput.component";
import ScrollableTable from "../../../../components/Universal/Tables/ScrollableTable.component";
import TableUserProfileView from "../../../../components/Universal/TableTypeUserProfile/TableUserProfileView.component";
import TestProfileImage from "../../../../assets/Images/TestImg/profileImage.png";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import Title from "../../../../components/Universal/Title.component";
import HostelStore from "../../../../store/Operational/Residential/Hostel";
import FormInput from "../../../../components/Universal/FormInput.component";
import { useEffect, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import PlusIcon from "../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import CrossIcon from "../../../../assets/Icons/Universal/CrossHoloIcon.svg";
const Body = ({
  filter,
  setFilter,
  classesFilter,
  setClassesFilter,
  changeHostelPage,
  setChangeHostelPage,
  viewDetailsModal,
  setViewDetailsModal,
  viewDetailsModalFilters,
  setViewDetailsModalFilters,
  addHostelModal,
  setAddHostelModal,
}) => {
  const { hostelId, action } = HostelStore();
  useEffect(() => {
    if (action === "view") {
      setViewDetailsModal(true);
    } else if (action === "edit") {
    }
  }, [hostelId, action, setViewDetailsModal]);
  const [selectedFloorIndex, setSelectedFloorIndex] = useState(0);

  return (
    <section className="hostelPage flex-col align-start justify-start g-1 pr-1">
      <Helmet>
        <title>Hostel Management</title>
      </Helmet>
      {/* hostel view Details Modal */}
      <SecondModal
        isOpen={viewDetailsModal}
        onClose={setViewDetailsModal}
        isCrossBtn
      >
        <div
          className="flex-col align-start justify-start g-1"
          style={{ width: "35vw" }}
        >
          {/* modal header */}
          <div className="w-full flex-row align-center justify-between">
            <Title>Hostel {hostelId}</Title>
            <div className="flex-row align-center justify-start pr-2">
              {/* header action btns */}
              <div className="flex-row align-center justify-start g-1">
                <button className="actionBtn">Renew</button>
                <button
                  className="deleteBtn pl-1 pr-1"
                  style={{ background: "var(--redColor)", color: "white" }}
                >
                  Delete room
                </button>
              </div>
            </div>
          </div>
          {/* modal filter btns */}
          <div className="flex-row align-center justify-start g-2">
            <div className="flex" style={{ width: "11rem" }}>
              <DropDownInput
                type="select"
                name="floor"
                label="Floor number"
                setFieldValue={(val) =>
                  setViewDetailsModalFilters({
                    ...viewDetailsModalFilters,
                    floor: val,
                  })
                }
                placeholder={"Floor No."}
                suggestionList={["1", "2", "3"]}
              />
            </div>
            <div className="flex" style={{ width: "11rem" }}>
              <DropDownInput
                type="select"
                name="room"
                label="Room number"
                setFieldValue={(val) =>
                  setViewDetailsModalFilters({
                    ...viewDetailsModalFilters,
                    room: val,
                  })
                }
                placeholder={"Room No."}
                suggestionList={["1", "2", "3"]}
              />
            </div>
          </div>
          {/* person count and staffs filter btn */}
          <div
            className="w-full flex-row align-center justify-between pb-05"
            style={{ borderBottom: "2px solid var(--grayBorder)" }}
          >
            <span className="color-greenColor poppins t-13">15 students</span>
            <div className="toggleBtn">
              <label htmlFor="staffs">Staffs</label>
              <input
                type="checkbox"
                checked={viewDetailsModalFilters.isStaffs}
                name="isStaffs"
                onChange={(e) =>
                  setViewDetailsModalFilters({
                    ...viewDetailsModalFilters,
                    [e.target.name]: e.target.checked,
                  })
                }
              />
            </div>
          </div>

          <div
            className="flex-col align-start justify-start scroll-y pr-1"
            style={{ height: "50vh" }}
          >
            {viewDetailsModalFilters.isStaffs ? (
              <ScrollableTable
                thead={["Residents", "Designation", "Appearance"]}
              >
                {[...Array(20)].map(() => {
                  return (
                    <tr>
                      <td>
                        <TableUserProfileView
                          src={TestProfileImage}
                          imageDimenssion={[45, 45]}
                          title="Toufik Alam"
                          description={"ID: SM0523019"}
                        />
                      </td>
                      <td className="color-greenColor">Teacher</td>
                      <td className="color-greenColor">30%</td>
                      {/* <td>
                        <div className="flex-row align-center justify-end">
                          <button className="deleteBtnFill pl-1 pr-1" style={{}}>
                            Remove
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  );
                })}
              </ScrollableTable>
            ) : (
              <ScrollableTable
                thead={["Residents", "Class", "Appearance", "Modify"]}
              >
                {[...Array(20)].map(() => {
                  return (
                    <tr>
                      <td>
                        <TableUserProfileView
                          src={TestProfileImage}
                          imageDimenssion={[45, 45]}
                          title="Toufik Alam"
                          description={"ID: SM0523019"}
                        />
                      </td>
                      <td className="color-greenColor">5/A</td>
                      <td className="color-greenColor">30%</td>
                      <td>
                        <div className="flex-row align-center justify-end">
                          <button
                            className="deleteBtnFill pl-1 pr-1"
                            style={{}}
                          >
                            Remove
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </ScrollableTable>
            )}
          </div>
        </div>
      </SecondModal>
      {/* edit hostel modal */}
      {/* add new hostel modal */}
      <SecondModal
        isOpen={addHostelModal}
        onClose={setAddHostelModal}
        isCrossBtn
      >
        <Formik
          initialValues={{
            gender: "",
            shuffleMode: false,
            hostelname: "",
            totalFloors: "",
            wardenName: "",
            totalRooms: "",
            roomNoCountStart: false,
            allRoomWithSameNo: false,
            sameRoomAllFloor: false,
            floorMatrix: [
              {
                floorName: "Ground Floor",
                floorDetails: [
                  {
                    roomNo: "",
                    className: "",
                    staffsSeat: "",
                    studentSeat: "",
                  },
                ],
              },
              {
                floorName: "1st Floor",
                floorDetails: [
                  {
                    roomNo: "",
                    className: "",
                    staffsSeat: "",
                    studentSeat: "",
                  },
                ],
              },
            ],
          }}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ values, setFieldValue, touched, errors, setTouched }) => {
            const wardenNameSuggestionList = [
              "warden suggestions 1",
              "warden suggestions 2",
              "warden suggestions 3",
              "warden suggestions 4",
            ];
            const handleSelectFloor = (index) => {
              setSelectedFloorIndex(index);
            };
            return (
              <Form>
                <div
                  className="flex-col align-start justify-start g-2 scroll-y pr-1"
                  style={{ width: "50vw", maxHeight: "80vh" }}
                >
                  <div className="flex-row align-center justify-start g-3">
                    <Title style={{ color: "black", fontSize: "16px" }}>
                      Add hostel
                    </Title>
                    <div className="flex-row align-center justify-start pr-2">
                      {/* header action btns */}
                      <div className="flex-row align-center justify-start g-1">
                        <TogglePushBtn
                          type="radio"
                          setVal={(val) => setFieldValue("gender", val)}
                          name="gender"
                          value={values.gender}
                          icon={
                            <PersonIcon
                              fill="white"
                              style={{ width: "1.3rem", height: "1.3rem" }}
                            />
                          }
                          icontype="svg"
                          label="All"
                        />
                        <TogglePushBtn
                          type="radio"
                          setVal={(val) => setFieldValue("gender", val)}
                          name="gender"
                          value={values.gender}
                          icon={
                            <PersonInMobileIcon
                              fill="white"
                              style={{ width: "1.3rem", height: "1.3rem" }}
                            />
                          }
                          icontype="svg"
                          label="Boys"
                        />
                        <TogglePushBtn
                          type="radio"
                          setVal={(val) => setFieldValue("gender", val)}
                          name="gender"
                          value={values.gender}
                          icon={
                            <PersonInMobileIcon
                              fill="white"
                              style={{ width: "1.3rem", height: "1.3rem" }}
                            />
                          }
                          icontype="svg"
                          label="Girls"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="poppins t-12">
                    If you don’t click the toggle, rooms are arranged bottom-up
                    approach of a hostel. And students are alloted in a same
                    room on behalf of their classes sequence.
                  </div>
                  {/* toggle buttons for room  allotment */}
                  <div className="flex-row align-center justify-start g-3">
                    <div className="toggleBtn">
                      <label
                        htmlFor="Room no"
                        className="t-10"
                        style={{ fontSize: "12px" }}
                      >
                        Room numbers start from each floor
                      </label>
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          setFieldValue("roomNoCountStart", e.target.checked)
                        }
                        checked={values.roomNoCountStart}
                        name="roomNoCountStart"
                      />
                    </div>
                    <div className="toggleBtn">
                      <label
                        htmlFor="shuffle mode Room no"
                        className="t-10"
                        style={{ fontSize: "12px" }}
                      >
                        Students of various classes are arranged in a shuffle
                        mode in a room
                      </label>
                      <input
                        type="checkbox"
                        name="shuffleMode"
                        onChange={(e) =>
                          setFieldValue("shuffleMode", e.target.checked)
                        }
                        checked={values.shuffleMode}
                      />
                    </div>
                  </div>
                  {/* hostel details textInputs  */}
                  <div className="hostelModalInputsContainer">
                    <FormInput
                      label="Hostel name"
                      type="text"
                      name="hostelName"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter hostel unique name"
                      setFieldValue={(e) =>
                        setFieldValue("hostelName", e.target.value)
                      }
                    />
                    <FormInput
                      label="Floor number"
                      type="number"
                      name="floorNumber"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter total floors in this hostel"
                      setFieldValue={(e) =>
                        setFieldValue("floorNumber", e.target.value)
                      }
                    />
                    <DropDownInput
                      type="text"
                      name="wardenName"
                      label="Warden"
                      setFieldValue={(val) => setFieldValue("wardenName", val)}
                      placeholder={"Choose warden name"}
                      suggestionList={wardenNameSuggestionList}
                      setTouched={(name, isTouched) =>
                        setTouched({ [name]: isTouched })
                      }
                    />
                    <FormInput
                      label="Total rooms"
                      type="numbers"
                      name="totalRooms"
                      touched={touched}
                      errors={errors}
                      placeholder="Enter total rooms count"
                      setFieldValue={(e) =>
                        setFieldValue("totalRooms", e.target.value)
                      }
                    />
                    <div className="toggleBtn">
                      <label
                        htmlFor="Room no"
                        className="t-10"
                        style={{ fontSize: "12px" }}
                      >
                        All floors contain same number of rooms
                      </label>
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          setFieldValue("sameRoomAllFloor", e.target.checked)
                        }
                        checked={values.sameRoomAllFloor}
                        name="sameRoomAllFloor"
                      />
                    </div>
                  </div>
                  <div className="w-full flex-col align-start justify-start g-1">
                    <div className="w-full flex-row align-center justify-between">
                      <Title>Room seat matrix</Title>
                      <div className="toggleBtn">
                        <label
                          htmlFor="Room no"
                          className="t-10"
                          style={{ fontSize: "14px" }}
                        >
                          Create all rooms with same number of students and
                          staffs
                        </label>
                        <input type="checkbox" name="sameNoOfStudentTeachers" />
                      </div>
                    </div>
                    {/* scrollable floor list */}
                    <div className="flex-row scroll-x w-full pb-1">
                      <div className="w-fit flex-row align-center justify-between g-1">
                        {values.floorMatrix.map((item, index) => {
                          return (
                            <TogglePushBtn
                              key={index}
                              type="checkbox"
                              name="floorName"
                              label={item.floorName}
                              value={
                                values.floorMatrix[selectedFloorIndex]
                                  .floorName === item.floorName
                                  ? item.floorName
                                  : ""
                              }
                              setVal={() => handleSelectFloor(index)}
                              initialBackColor="#E4E0FF"
                              initialColor="#5E4DE1"
                              checkedBackColor="#5E4DE1"
                              initialBorderColor="#5E4DE1"
                              lableStyle={{ fontSize: "13px" }}
                              btnStyle={{ height: "3rem", width: "10rem" }}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div
                      className="flex-col align-start justify-start g-1 scroll-y pr-1"
                      style={{ height: "20vh" }}
                    >
                      <FieldArray
                        name={`floorMatrix[${selectedFloorIndex}].floorDetails`}
                      >
                        {({ push, remove }) => (
                          <div className="flex-col align-start justify-start g-1">
                            {values.floorMatrix[
                              selectedFloorIndex
                            ].floorDetails.map((_, detailIndex) => (
                              <div className="flex-row align-center justify-start g-1">
                                <FormInput
                                  label="Room number"
                                  name={`floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].roomNo`}
                                  type="text"
                                  touched={touched}
                                  errors={errors}
                                  placeholder="Enter room no"
                                  setFieldValue={(e) =>
                                    setFieldValue(
                                      `floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].roomNo`,
                                      e.target.value
                                    )
                                  }
                                />
                                <FormInput
                                  label="Class Name"
                                  name={`floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].className`}
                                  type="text"
                                  touched={touched}
                                  errors={errors}
                                  placeholder="Enter class name"
                                  setFieldValue={(e) =>
                                    setFieldValue(
                                      `floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].className`,
                                      e.target.value
                                    )
                                  }
                                />
                                <FormInput
                                  label="Alloted staff seats"
                                  name={`floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].staffsSeat`}
                                  type="text"
                                  touched={touched}
                                  errors={errors}
                                  placeholder="Enter staff seats counts"
                                  setFieldValue={(e) =>
                                    setFieldValue(
                                      `floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].staffsSeat`,
                                      e.target.value
                                    )
                                  }
                                />
                                <FormInput
                                  label="Alloted student seats"
                                  name={`floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].studentSeat`}
                                  type="text"
                                  touched={touched}
                                  errors={errors}
                                  placeholder="Enter student seat counts"
                                  setFieldValue={(e) =>
                                    setFieldValue(
                                      `floorMatrix[${selectedFloorIndex}].floorDetails[${detailIndex}].studentSeat`,
                                      e.target.value
                                    )
                                  }
                                />
                                <div className="flex-col align-center justify-center pt-1">
                                  <button
                                    className="transparentBtn"
                                    type="button"
                                    onClick={() => remove(detailIndex)}
                                    style={{ marginTop: "0.5rem" }}
                                  >
                                    <img src={CrossIcon} alt="" />
                                  </button>
                                </div>
                              </div>
                            ))}
                            {/* add button for adding new item for floor matrix */}
                            <button
                              type="button"
                              className="transparentBtn w-fit flex-row align-center justify start g-05"
                              onClick={() =>
                                push({
                                  totalRooms: "",
                                  className: "",
                                  staffsSeat: "",
                                  studentSeat: "",
                                })
                              }
                            >
                              <img
                                src={PlusIcon}
                                alt="plusIcon"
                                style={{ width: "2rem", height: "2rem" }}
                              />
                              <span className="t-17 poppins-medium">Add</span>
                            </button>
                          </div>
                        )}
                      </FieldArray>
                    </div>
                  </div>

                  <div className="w-full flex-row align-center justify-center ">
                    <button
                      className="actionBtn"
                      style={{ width: "70%", height: "3rem" }}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </SecondModal>

      {/* page header  */}
      <PageHeader
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />

            <div className="flex-col g-05 align-start justify-end">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Type for search"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="searchBtn" />
                </button>
              </div>
            </div>

            <TogglePushBtn
              type="checkbox"
              name="myToggle"
              label="Edit Hostel"
              value={changeHostelPage ? "Edit Hostel" : ""}
              setVal={() => {
                setChangeHostelPage((prev) => !prev);
              }}
              initialBackColor="#E4E0FF"
              initialColor="#5E4DE1"
              checkedBackColor="#5E4DE1"
              initialBorderColor="#5E4DE1"
              lableStyle={{ fontSize: "13px" }}
              btnStyle={{ height: "calc(100% - 4px)" }}
            />
          </div>
        }
      />
      <div
        className="flex align-start justify-start"
        style={{ background: "transparent" }}
      >
        {changeHostelPage ? (
          <HostelEdit />
        ) : (
          <HostelBody setAddHostelModal={setAddHostelModal} />
        )}
      </div>
    </section>
  );
};

export default Body;
